var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.route.name?.includes('prefix-collection-id'))?_c('div',[_c(_setup.NeoTooltip,{attrs:{"label":"Coming Soon","position":"bottom"}},[_c(_setup.NeoButton,{staticClass:"offer w-100",attrs:{"label":"Make Collection Offer","disabled":""}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }